import ContactForm from './ContactForm'

export default ContactForm
